import { makeStyles } from '@material-ui/core/styles';
import { DIMENSIONS } from '../../../styles/constants';

export const useStyles = makeStyles(theme => ({
	tableFooterRoot: {
		display: 'block'
	},
	tableFooterContainer: {
		minHeight: DIMENSIONS.COMPONENT_HEADER_HEIGHT
	},
	vinNomNote: {
		paddingLeft: theme.spacing(2)
	},
	focusableButton: {
		'&:focus': {
			boxShadow: ''
		}
	},
	footerPagination: {
		'& svg': {
			top: 2.8
		}
	}
}));
